/**
 * yuga-facets-fix.js
 * Removes A-Z / Z-A sort options and sets Best Selling as default.
 */
(function () {
  const SORT_PARAM = 'sort_by';
  const HIDDEN_SORTS = ['title-ascending', 'title-descending'];
  const DEFAULT_SORT = 'best-selling';

  function fixSortSelect() {
    const selects = document.querySelectorAll(
      'select[name="sort_by"], [data-sort-select], .facets__sort select'
    );

    selects.forEach(function (select) {
      // Remove unwanted options
      HIDDEN_SORTS.forEach(function (val) {
        const opt = select.querySelector('option[value="' + val + '"]');
        if (opt) opt.remove();
      });

      // Set Best Selling as default only if no sort param is in the URL
      const url = new URL(window.location.href);
      if (!url.searchParams.get(SORT_PARAM)) {
        const bestSelling = select.querySelector('option[value="' + DEFAULT_SORT + '"]');
        if (bestSelling) {
          select.value = DEFAULT_SORT;
        }
      }
    });
  }

  function init() {
    fixSortSelect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reapply on browser back/forward navigation
  window.addEventListener('popstate', fixSortSelect);

  // Reapply after Shopify section re-renders (theme events)
  document.addEventListener('shopify:section:load', fixSortSelect);
})();